jQuery(document).ready(($) => {

    function CountDownTimer(dt, id) {
        let end = new Date(dt)

        let _second = 1000
        let _minute = _second * 60
        let _hour = _minute * 60
        let _day = _hour * 24
        let timer

        function showRemaining() {
            // console.log("tick")
            let now = new Date()
            let distance = end - now
            if (distance < 0) {

                clearInterval(timer)
                $(id).remove()

                return
            }
            let days = Math.floor(distance / _day)
            let hours = Math.floor((distance % _day) / _hour)
            let minutes = Math.floor((distance % _hour) / _minute)
            let seconds = Math.floor((distance % _minute) / _second)

            if(days == 1) {
                $(id + " .days .num").html(days)
                $(id + " .days .string").html('day')
            } else if(days != 0) {
                $(id + " .days .num").html(days)
                $(id + " .days .string").html('days')
            } else {
                $(id + ".days").remove()
            }

            if(hours == 1) {
                $(id + " .hours .num").html(hours)
                $(id + " .hours .string").html('hour')
            } else {
                $(id + " .hours .num").html(hours)
                $(id + " .hours .string").html('hours')
            }

            if(minutes == 1) {
                $(id + " .minutes .num").html(minutes)
                $(id + " .minutes .string").html('minute')
            } else {
                $(id + " .minutes .num").html(minutes)
                $(id + " .minutes .string").html('minutes')
            }

            if(seconds == 1) {
                $(id + " .seconds .num").html(seconds)
                $(id + " .seconds .string").html('second')
            } else {
                $(id + " .seconds .num").html(seconds)
                $(id + " .seconds .string").html('seconds')
            }
        }

        showRemaining()
        timer = setInterval(showRemaining, 1000)
    }

    if($('#event-countdown').length) {
        CountDownTimer('2023-08-18 16:00:00', '#event-countdown')
    }

    function Slider(array,selector) {
        let current_slide = 0
        let length = BACKGROUND_IMAGES.length
        let timer

        function slide(initial = false) {
            if(!initial) {
                if( current_slide >= length - 1 ) {
                    current_slide = 0
                } else {
                    current_slide++
                }
            }

            //console.log(BACKGROUND_IMAGES)
            //console.log(BACKGROUND_IMAGES[current_slide])

            $(selector).css('background-image', 'url(' + BACKGROUND_IMAGES[current_slide] + ')')
        }

        slide(true)
        timer = setInterval(slide, 10000)
    }

    if(typeof BACKGROUND_IMAGES !== "undefined" && BACKGROUND_IMAGES.length > 0) {
        Slider(BACKGROUND_IMAGES, '.feaa-slider')
    }

});
